const activeRequests = new Map<string, AbortController>();

export const cancelPreviousRequests = (endpointKey: string) => {
  if (activeRequests.has(endpointKey)) {
    activeRequests.get(endpointKey)?.abort();
    activeRequests.delete(endpointKey);
  }
};

export const registerNewRequest = (endpointKey: string, controller: AbortController) => {
  activeRequests.set(endpointKey, controller);
};